import { CapitalizeFirstLetter } from '@cdab/headless-components'
import styled from 'styled-components'

export interface StatusBadgeProps {
  text: string
  tdsColorVar: string
  className?: string
}

const StyledStatusBadge = styled.div<StatusBadgeProps>`
  display: inline-block;
  background: var(${props => props.tdsColorVar});
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 999px;
`

export function StatusBadge(props: StatusBadgeProps) {
  return (
    <StyledStatusBadge {...props}>
      <CapitalizeFirstLetter>{props.text}</CapitalizeFirstLetter>
    </StyledStatusBadge>
  )
}

export default StatusBadge
